import brandPortalOrders from "@faire/web-api/routes/brand-portal/orders";
import brandPortalOrdersbrandOrderTokenEdit from "@faire/web-api/routes/brand-portal/orders/brandOrderToken/edit";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
export var EditOrderInformationIA = function EditOrderInformationIA(_ref) {
  var _context$brandOrder, _context$brandOrder$b;
  var context = _ref.context;
  var brandOrderToken = (_context$brandOrder = context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : (_context$brandOrder$b = _context$brandOrder.brand_order) === null || _context$brandOrder$b === void 0 ? void 0 : _context$brandOrder$b.token;
  if (brandOrderToken) {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "ea0MKp",
      defaultMessage: [{
        "type": 0,
        "value": "Pour modifier les informations de la commande, accédez d'abord à la "
      }, {
        "children": [{
          "type": 0,
          "value": "page Détails de la commande"
        }],
        "type": 8,
        "value": "OrderDetailsLinkFormatting"
      }, {
        "type": 0,
        "value": ". Sélectionnez ensuite le lien "
      }, {
        "children": [{
          "type": 0,
          "value": "Modifier"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }, {
        "type": 0,
        "value": " pour adapter les détails de l'expédition, les promotions ou les produits."
      }],
      values: {
        LinkFormatting: function LinkFormatting(chunks) {
          return EditOrderLinkFormatting(chunks, brandOrderToken);
        },
        OrderDetailsLinkFormatting: function OrderDetailsLinkFormatting(chunks) {
          return OrderLinkFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "V3/NqV",
      defaultMessage: [{
        "type": 0,
        "value": "Vous pouvez modifier l'adresse d'expédition ou la date d'expédition en cliquant sur l'icône en forme de stylo à côté des champs correspondants. Après avoir effectué vos modifications, cliquez sur "
      }, {
        "children": [{
          "type": 0,
          "value": "Mettre à jour"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " pour les enregistrer."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "4Xj61v",
      defaultMessage: [{
        "type": 0,
        "value": "Vous pouvez modifier les quantités de produits en modifiant les champs "
      }, {
        "children": [{
          "type": 0,
          "value": "Qté"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ". Vous pouvez également appliquer une promotion à la commande, ou la supprimer."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "aQBXiZ",
      defaultMessage: [{
        "type": 0,
        "value": "Lorsque vous apportez des modifications, vous avez la possibilité de laisser un message au commerçant, ce que nous vous recommandons vivement pour une expérience client positive. Le commerçant recevra une notification par e-mail détaillant les modifications effectuées."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })));
  } else {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "XGPsSb",
      defaultMessage: [{
        "type": 0,
        "value": "Pour modifier les informations d'une nouvelle commande ou d'une commande non exécutée, accédez d'abord à vos "
      }, {
        "children": [{
          "type": 0,
          "value": "Commandes"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }, {
        "type": 0,
        "value": ", puis à la page des "
      }, {
        "children": [{
          "type": 0,
          "value": "détails de la commande"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " que vous souhaitez modifier. Sélectionnez ensuite le lien "
      }, {
        "children": [{
          "type": 0,
          "value": "Modifier"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " pour adapter les détails de l'expédition, les promotions ou les produits."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        },
        LinkFormatting: function LinkFormatting(chunks) {
          return OrderLinkFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "1Bp3jy",
      defaultMessage: [{
        "type": 0,
        "value": "Vous pouvez modifier l'adresse d'expédition ou la date d'expédition en cliquant sur l'icône en forme de stylo à côté des champs correspondants. Après avoir effectué vos modifications, cliquez sur "
      }, {
        "children": [{
          "type": 0,
          "value": "Mettre à jour"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " pour les enregistrer."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "AXd4P9",
      defaultMessage: [{
        "type": 0,
        "value": "Vous pouvez modifier les quantités de produits en modifiant les champs "
      }, {
        "children": [{
          "type": 0,
          "value": "Qté"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ". Vous pouvez également appliquer une promotion à la commande, ou la supprimer."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "yD2687",
      defaultMessage: [{
        "type": 0,
        "value": "Lorsque vous apportez des modifications, vous avez la possibilité de laisser un message au commerçant, ce que nous vous recommandons vivement pour une expérience client positive. Le commerçant recevra une notification par e-mail détaillant les modifications effectuées."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })));
  }
};
var EditOrderLinkFormatting = function EditOrderLinkFormatting(chunks, brandOrderToken) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalOrdersbrandOrderTokenEdit(brandOrderToken),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var OrderLinkFormatting = function OrderLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalOrders(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};